import BigNumber from 'bignumber.js';
import { Address, PublicClient } from 'viem';

import { SECONDS_IN_DAY } from 'modules/api/const';
import { getLiquidStakingTokenContract } from 'modules/api/contracts/getLiquidStakingTokenContract';
import { convertBlocksToSeconds } from 'modules/api/utils';
import { ONE } from 'modules/common/const';

export async function getLiquidUnstakePeriodDays(
  client: PublicClient,
  poolAddress?: Address,
): Promise<BigNumber> {
  const contract = getLiquidStakingTokenContract(client, poolAddress);

  const blocksRaw = await contract.read.UNBONDING_PERIOD();

  const days = new BigNumber(convertBlocksToSeconds(Number(blocksRaw))).div(
    SECONDS_IN_DAY,
  );

  return days.isGreaterThan(ONE) ? days.integerValue() : days.decimalPlaces(3);
}
